import { render, staticRenderFns } from "./CategoryImageCarousel.vue?vue&type=template&id=4846761d&"
import script from "./CategoryImageCarousel.vue?vue&type=script&lang=js&"
export * from "./CategoryImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/51881/189/Woerner/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4846761d')) {
      api.createRecord('4846761d', component.options)
    } else {
      api.reload('4846761d', component.options)
    }
    module.hot.accept("./CategoryImageCarousel.vue?vue&type=template&id=4846761d&", function () {
      api.rerender('4846761d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/CategoryImageCarousel.vue"
export default component.exports